// The Vue build version to load with the `import` command (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router';
import store from './store/';
import App from './pages/App'


Vue.config.productionTip = false;

/* eslint-disable no-new */
/* eslint-disable no-new */
new Vue({
	el: '#app',
	created: function () {
		window.Vue = this
	},
	router,
	store,
	render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js